import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { ProtectedAdminRoute } from '~/util/ProtectedAdminRoute';
import { ProtectedRoute } from '~/util/ProtectedRoute';
import { logError } from '~/util';
import { MfaEnrollment } from '~/components/Auth/Mfa/MfaEnrollment';
import { Dashboard } from './Patients/Dashboard';
import { Reminders } from './Patients/Reminders';
import { User } from './User';
import { Patients } from './Patients';
import { Error404 } from './Error';
import { Login } from './Auth/Login';
import { Mfa } from './Auth/Mfa';
import { Forgot } from './Auth/Forgot';
import { Reset } from './Auth/Reset';
import { Expired } from './Auth/Expired';
import { Logout } from './Auth/Logout';
import { Admin } from './Admin';
import { PageFallback } from './PageFallback';
import { Resources } from './Resources';

// Type assertions for TypeScript 5.x compatibility with react-router-dom v5
const SwitchComponent = Switch as any;
const RouteComponent = Route as any;

export function Pages() {
    return (
        <ErrorBoundary FallbackComponent={PageFallback} onError={logError}>
            <SwitchComponent>
                <ProtectedAdminRoute path="/admin" component={Admin} />
                <ProtectedRoute path="/dashboard" component={Dashboard} exact />
                <ProtectedRoute path="/reminders" component={Reminders} exact />
                <ProtectedRoute path="/user" component={User} />
                <ProtectedRoute path="/patients" component={Patients} />
                <ProtectedRoute path="/resources" component={Resources} />

                <RouteComponent path="/mfa" component={Mfa} exact />
                <RouteComponent path="/mfa-enrollment" component={MfaEnrollment} exact />
                <RouteComponent path="/forgot" component={Forgot} exact />
                <RouteComponent path="/reset" component={Reset} exact />
                <RouteComponent path="/reset/expired/:token" component={Expired} exact />
                <RouteComponent path="/logout" component={Logout} exact />
                <RouteComponent path="/" component={Login} exact />
                <RouteComponent path="*" component={Error404} />
            </SwitchComponent>
        </ErrorBoundary>
    );
}
